import { $api } from "../generated/client";

export const useGetCustomerPortalLink = (shopId: string) => {
	return $api.useQuery("get", "/shops/{shopId}/billings/portal-link", {
		params: { path: { shopId } },
	});
};
